<template>
	<VuePerfectScrollbar style="height: calc(100dvh - 5.9rem); background-color: #f5f5f5">
		<div class="d-flex flex-column flex-md-row flex-fill justify-content-between p-3 p-md-0" style="margin-top: 2rem">
			<div class="d-flex flex-fill justify-content-center align-items-end mb-4 mb-md-0">
				<img src="/background/affiliate-program/affiliate-program-background-2.svg" style="width: 22.5rem; max-width: 100%;"
					alt="" />
			</div>
			<div class="d-flex flex-column justify-content-center align-items-center">
				<img src="/logo/iRender-fulltext.svg" style="height: 2rem" alt="" />
				<div style=" color: #1967d2; font-size: 1.5rem; margin-top: 0.5rem; text-shadow: 2px 2px #ffffff; ">
					Affiliate program
				</div>
				<div @click="copyLinkAffiliate(`#linkAffiliate`)" class="d-flex"
					style="width: 27.5rem; margin-top: 0.75rem; max-width: 100%;">
					<el-input id="linkAffiliate" class="d-flex flex-fill" placeholder="Link share ... "
						:value="hostUrl + '/register?affiliateId=' + user.affiliateId">
						<i slot="prefix" class="el-input__icon el-icon-link"></i>
					</el-input>
				</div>
			</div>
			<div class="d-none d-md-flex flex-fill justify-content-center align-items-end">
				<img src="/background/affiliate-program/affiliate-program-background-1.svg" style="width: 22.5rem; max-width: 100%;"
					alt="" />
			</div>
		</div>
		<div class="flex-column d-flex align-items-center mt-5" style="font-size: 1rem">
			<div class="div">Share your referral link with whoever needs render</div>
			<div class="div">
				Receive
				<span style="color: #f44336">20%</span> for first time and
				<span style="color: #f44336">5%</span> for next time
			</div>
			<div>when your referrals recharge successfully.</div>
			<div style="color: #f44336">Expire one year from the 1st recharge.</div>
		</div>
		<div class="d-block d-md-none flex-fill justify-content-center align-items-end">
			<img src="/background/affiliate-program/affiliate-program-background-1.svg" style="width: 22.5rem; max-width: 100%;"
				alt="" />
		</div>
	</VuePerfectScrollbar>
</template>

<script>
// Lib
import { Notification } from "element-ui";
import { mapState } from "vuex";

// Constant
import { HOST_URL } from "@/constant/routeApi";

export default {
	data() {
		return {
			hostUrl: HOST_URL.CLIENT_URL,
		};
	},

	computed: {
		...mapState({
			user: (state) => state.auth.user,
		}),
	},

	methods: {
		copyLinkAffiliate(inputId) {
			const el = document.querySelector(inputId);
			el.select();
			el.setSelectionRange(0, 99999);
			$(inputId).show();
			el.focus();
			document.execCommand("copy");
			Notification.success({
				title: "Copied",
				duration: 1500,
				showClose: false,
				message: `The address has been copied`,
			});
		},
	},
};
</script>